export default __webpack_public_path__ + "media/4e4349d426eb6f9d4cded8d5aa083e7e49bf495e14118afe523e2cb3cbecac6f.svg";